/**
 * i18n лендинга: ru (default) / uz (латиница) / en.
 * Локаль определяется URL-путём (/ → ru, /uz/ → uz, /en/ → en): каждая локаль —
 * отдельная статическая страница (пререндер, hreflang) — H-71/H-72.
 * Выбор дублируется в localStorage('hubario_lang') — общий ключ с кабинетом.
 */
import { createI18n } from 'vue-i18n'
import ru, { type LandingSchema } from './ru'
import uz from './uz'
import en from './en'

export const SUPPORTED_LANGS = ['ru', 'uz', 'en'] as const
export type Lang = (typeof SUPPORTED_LANGS)[number]

/** Словари напрямую (для типизированного доступа к массивам steps/features). */
export const messages: Record<Lang, LandingSchema> = { ru, uz, en }

const STORAGE_KEY = 'hubario_lang'

/** Локаль из пути: /uz/... → uz, /en/... → en, иначе ru. */
export function localeFromPath(path: string): Lang {
  const m = /^\/(uz|en)(\/|$)/.exec(path)
  return (m?.[1] as Lang | undefined) ?? 'ru'
}

/** Путь страницы локали (для навигации пилюли и пререндера). */
export function pathForLocale(lang: Lang): string {
  return lang === 'ru' ? '/' : `/${lang}/`
}

/** Экземпляр i18n под локаль — общий для клиента и SSR-пререндера. */
export function makeI18n(locale: Lang) {
  return createI18n({
    legacy: false,
    locale,
    fallbackLocale: 'ru',
    messages,
  })
}

/** Сменить язык: localStorage (общий с кабинетом) + переход на страницу локали. */
export function setLang(lang: Lang): void {
  localStorage.setItem(STORAGE_KEY, lang)
  window.location.assign(pathForLocale(lang))
}

/**
 * <html lang>/<title>/description под локаль. В проде всё уже запечено
 * пререндером — это страховка для dev-сервера (там статики нет).
 */
export function applyMeta(lang: Lang): void {
  document.documentElement.lang = lang
  document.title = messages[lang].meta.title
  document
    .querySelector('meta[name="description"]')
    ?.setAttribute('content', messages[lang].meta.description)
}
